import React from "react";

const steps = [
  {
    id: 1,
    title: "Upload or connect",
    description:
      "Sync your invoicing tool or upload a PDF. We verify buyer credibility and invoice data.",
  },
  {
    id: 2,
    title: "Get advance offer",
    description:
      "Receive a tailored advance rate and fee estimate instantly based on risk profile.",
  },
  {
    id: 3,
    title: "Receive funds",
    description:
      "Accept the offer and receive funds in 24–48 hours into your business account.",
  },
  {
    id: 4,
    title: "Settle & repeat",
    description:
      "When your customer pays, we settle the discount and you can finance the next invoice.",
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-2xl font-semibold text-gray-900">
            How It Works
          </h2>

          <span className="inline-flex items-center rounded-full border border-gray-200 px-4 py-1 text-sm text-gray-500">
            4 simple steps
          </span>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step) => (
            <div
              key={step.id}
              className="bg-[#FAFAFA] border border-gray-200 rounded-xl p-6"
            >
              <div className="flex gap-4">
                {/* Step Number */}
                <div className="flex-shrink-0">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#D9F4EF] text-sm font-semibold text-[#0FB9B1]">
                    {step.id}
                  </span>
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
